module.exports = __webpack_public_path__ + "img/highway-traffic.143e299a.jpg";